import {
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Asset DNS field definition
 * Free-text input (no preset values)
 */
export const AssetDNS: SimpleFilterDefinition = {
  apiField: 'dns',
  uiField: 'DNS',
  inputType: 'text',
  operators: ['is', 'is not', 'contains', 'starts with', 'ends with'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'DNS',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: queryFilter.value as string | string[],
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    return {
      field: 'dns',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: simpleFilter.value,
    };
  },
};
